<div class="modal-header">
    <h4 class="modal-title">{{ isNew ? 'Add Receiver' : 'Edit Receiver' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (errorMessage) {
        <div class="alert alert-danger py-1 px-2 mb-2">{{ errorMessage }}</div>
    }
    <form #receiverForm="ngForm">
        <div class="form-group row mb5">
            <label for="receiver" class="col-sm-3 col-form-label">Receiver <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="receiver" name="receiver"
                    [(ngModel)]="model.receiver" required>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()"
        [disabled]="isSaving || !receiverForm.valid">
        @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Save
    </button>
</div>
